/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from "react";
import { VbzModal } from "@smiles/voebiz-ui-kit";
import { ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";
import { v4 } from "uuid";
import { FareRulesFirst, FareRulesLast } from "constants/fareRules";

import { MOBILE_SIZE } from "../../constants";
import { isGolPremiumEnabled } from "../../utils/cabinNomenclature";
import { DEFAULT_CANCELLATION_FEE, FlightRefundSegment, getCancellationRefundFee } from "../../utils/cancellationFee";

export interface IModalRules {
  classNameBody?: string;
  className?: string;
  isOpen: boolean;
  backdrop?: boolean;
  onClose?: () => void;
  toggle?: () => void;
  segments?: FlightRefundSegment[];
}
const ModalRules: React.FC<IModalRules> = ({
  classNameBody = "modal-body-flight-rules",
  className = "vbz-login-common",
  isOpen,
  backdrop = true,
  onClose,
  toggle,
  segments,
}) => {
  const { t } = useTranslation("modalRules");
  const flags = useFlags();
  const golPremiumEnabled = isGolPremiumEnabled(flags);
  const refundFee =
    golPremiumEnabled && segments && segments.length > 0
      ? getCancellationRefundFee(segments)
      : DEFAULT_CANCELLATION_FEE;
  const modalContentRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState(false);
  window.addEventListener("resize", () => {
    if (window.innerWidth < MOBILE_SIZE) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });
  useEffect(() => {
    if (window.innerWidth < MOBILE_SIZE) {
      setIsMobile(true);
    }
  }, [isMobile]);
  return (
    <VbzModal
      id={v4()}
      isOpen={isOpen}
      defaultHeader
      onClosed={onClose}
      desktopSize={!isMobile ? "big" : "small"}
      hasScroll
      type="right"
      backButton
      className={className}
      backdrop={backdrop}
      toggle={toggle}
    >
      <ModalBody className={classNameBody}>
        <div ref={modalContentRef}>
          <div className="fare-rules-container">
            <div className="fare-rules-title">
              <span>
                <strong>{t("title")}</strong>
              </span>
            </div>

            <div className="fare-rules-list">
              <div className="rules-list">
                {FareRulesFirst?.map((rule) => (
                  <div key={rule.id} className="fare-rule-item">
                    <strong>{t(rule.title)}</strong>
                    <p>{t(golPremiumEnabled && rule.textGolPremium ? rule.textGolPremium : rule.text)}</p>
                  </div>
                ))}
              </div>
              <div className="rules-list">
                {FareRulesLast?.map((rule) => (
                  <div key={rule.id} className="fare-rule-item">
                    <strong>{t(rule.title)}</strong>
                    <p>{t(rule.text, { refundFee })}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </VbzModal>
  );
};
export default ModalRules;
